import { Agency, agencyBasic } from '@app/models';
import { TrainType } from '@app/pcs/models/train-type';
import { TrainParameters, trainParametersDetailed } from '@dossier/models';
import { gql } from 'apollo-angular';

export interface AgencyParameterTemplate {
  id?: number;
  name?: string;
  imAgency?: Agency;
  trainType?: TrainType;
  trainParameters?: TrainParameters;
  hasCommonParameters?: boolean;
  hasImParameters?: boolean;
  editable?: boolean;
  ttpId?: number;
}

export const baseAgencyParameterTemplate = gql`
    fragment baseAgencyParameterTemplate on AgencyParameterTemplate {
        id
        name
    }
`;

export const agencyParameterTemplateEditable = gql`
    fragment agencyParameterTemplateEditable on AgencyParameterTemplate {
        editable
    }
`;

export const agencyParameterTemplateOverview = gql`
    fragment agencyParameterTemplateOverview on AgencyParameterTemplate {
        ...baseAgencyParameterTemplate
        imAgency {
            ...agencyBasic
        }
        trainType {
            id
            description
        }
        ...agencyParameterTemplateEditable
    }
    ${baseAgencyParameterTemplate}
    ${agencyBasic}
    ${agencyParameterTemplateEditable}
`;

export const agencyParameterTemplateDetailed = gql`
    fragment agencyParameterTemplateDetailed on AgencyParameterTemplate {
        ...agencyParameterTemplateOverview
        trainParameters {
            ...trainParametersDetailed
        }
        hasCommonParameters
        hasImParameters
        ttpId
    }
    ${agencyParameterTemplateOverview}
    ${trainParametersDetailed}
`;
